import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { PriceLevelDto } from '../dtos';

export enum PriceLevelsActionTypes {
  LoadPriceLevels = '[PriceLevels] LoadPriceLevels',
  LoadPriceLevelsSuccess = '[PriceLevels] LoadPriceLevelsSuccess',
  LoadPriceLevelsError = '[PriceLevels] LoadPriceLevelsError',
}

export const loadPriceLevelsAction = createAction(PriceLevelsActionTypes.LoadPriceLevels);
export const loadPriceLevelsSuccessAction = createAction(
  PriceLevelsActionTypes.LoadPriceLevelsSuccess,
  props<{ priceLevels: PriceLevelDto[] }>()
);
export const loadPriceLevelsErrorAction = createAction(PriceLevelsActionTypes.LoadPriceLevelsError, props<{ failure: AppStateFailure }>());
